// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import pageTemplatePageTheGame from './routes/page-template-page-the-game';
import pageTemplatePageTheEra from './routes/page-template-page-the-era';
import pageTemplatePageBabeBottleFinder from './routes/page-template-page-babe-bottle-finder';
import pageTemplatePageBabeBottleFinder25 from './routes/page-template-page-babe-bottle-finder-25';
import pageTemplatePageTheCircle from './routes/page-template-page-the-circle';
import pageTemplatePageAccolades from './routes/page-template-page-accolades';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  pageTemplatePageTheGame,
  pageTemplatePageTheEra,
  pageTemplatePageBabeBottleFinder,
  pageTemplatePageBabeBottleFinder25,
  pageTemplatePageTheCircle,
  pageTemplatePageAccolades,
});

// Load Events
document.addEventListener('DOMContentLoaded', () => routes.loadEvents(), false);


// WEBPACK FOOTER //
// ./scripts/main.js